import { Sanitize, sanitize as sanitizeData } from '@/core/utils/form-util';

const actions = {
    sku: [Sanitize],
    barcode: [Sanitize.trim],
    description: [Sanitize.trim],
    declaredValue: [Sanitize.round(2)],
    weight: [Sanitize.round(2)],
    length: [Sanitize.round(2)],
    width: [Sanitize.round(2)],
    height: [Sanitize.round(2)],
    originCountry: [Sanitize.trim],
};

export function sanitize(item) {
    return sanitizeData(item, actions);
}

export function sanitizeMultiple(items = []) {
    return items.map((item) => {
        const model = sanitizeData(item, actions);
        model.idx = undefined;
        return model;
    });
}
